module.exports = new __parcel__URL__("CantViewLight.81544b8c.svg").toString();